import { render, staticRenderFns } from "./AffiliateTable.vue?vue&type=template&id=448dc374&"
import script from "./AffiliateTable.vue?vue&type=script&lang=js&"
export * from "./AffiliateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports